export default __webpack_public_path__ + "static/media/logo29(2).0ce540a0.png";